// extracted by mini-css-extract-plugin
export default {"OnlyPlay":"OnlyPlay_OnlyPlay__Kw3sc","Logo":"OnlyPlay_Logo__nIGQy"};